module.exports = __webpack_public_path__ + "img/faq2.cfb90313.png";